export const purchaseDetails = (product) => {
  const physical = product.product_type === "physical" || ["Livre", "Livre papier"].includes(product.format);
  const url = product.purchase_url || (physical ? product.external_link || product.link : "") || "";
  const provider = product.purchase_provider || (physical ? "amazon" : "");
  return {
    physical,
    url,
    provider,
    external: Boolean(url),
    onsite: product.onsite_checkout_enabled === true && !physical && !url,
    label: provider === "amazon" ? "Acheter sur Amazon" : "Acheter sur Gumroad",
  };
};